var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiVerde(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3567_12235)",
    filter: "url(#filter0_d_3567_12235)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_3567_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4143 35.9985C31.6954 35.7686 38.2222 28.8684 37.9923 20.5863C37.7624 12.3043 30.863 5.77673 22.5819 6.00663C14.3008 6.23652 7.77399 13.1368 8.00385 21.4188C8.23372 29.7009 15.1332 36.2284 23.4143 35.9985Z",
    fill: "#FFCE00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.6202 14.7972C24.6602 15.1161 23.4749 15.1681 23.0035 15.1785C22.5322 15.1681 21.3399 15.1161 20.3834 14.7972C18.5604 14.1906 15.6248 13.8059 13.3859 13.8579C11.7293 13.8995 10.0137 14.1213 8.94623 14.3362C8.47142 14.4333 8.16989 14.8977 8.2808 15.3692L8.39517 15.8579C8.46102 16.1421 8.68283 16.3536 8.9601 16.4506C9.10219 16.5026 9.24083 16.5962 9.30321 16.7626C9.49383 17.279 10.5336 20.3397 11.095 21.4731C11.556 22.3986 12.8037 23.1924 15.7046 23.2062C19.8323 23.2236 21.2602 20.4922 21.9187 18.7314C21.9881 18.5477 22.092 18.1941 22.1856 17.851C22.3208 17.3622 22.6188 16.8804 22.7505 16.8111C22.8302 16.773 22.9204 16.7383 23.0105 16.7383C23.1006 16.7383 23.1942 16.773 23.2739 16.8111C23.4056 16.8804 23.6967 17.3622 23.8319 17.851C23.9254 18.1941 24.0294 18.5442 24.0987 18.7314C24.7538 20.4957 26.1851 23.2236 30.3095 23.2062C33.2103 23.1958 34.458 22.4021 34.919 21.4731C35.4804 20.3432 36.5167 17.279 36.7108 16.7626C36.7732 16.5962 36.9083 16.5026 37.0504 16.4506C37.3277 16.3536 37.546 16.1421 37.6154 15.8579L37.7297 15.3657C37.8372 14.8943 37.5357 14.4298 37.0643 14.3328C35.9968 14.1179 34.2813 13.896 32.6246 13.8544C30.3857 13.8024 27.4536 14.1872 25.6271 14.7938L25.6202 14.7972Z",
    fill: "#261F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9338 17.5355C25.0205 19.5355 26.9683 21.4558 28.7878 21.896C31.4669 22.5442 33.4805 21.9653 34.6242 19.5043C34.9673 18.7626 35.7055 17.1438 35.657 16.2808C35.5738 14.7799 33.6711 15.0433 32.4546 15.0156C32.3229 15.0156 24.8125 14.8007 24.9338 17.5355Z",
    fill: "#483D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1388 17.5355C21.0522 19.5355 19.1044 21.4558 17.2848 21.896C14.6058 22.5442 12.5921 21.9653 11.4484 19.5043C11.1053 18.7626 10.3671 17.1438 10.4156 16.2808C10.4988 14.7799 12.4015 15.0433 13.618 15.0156C13.7497 15.0156 21.2601 14.8007 21.1388 17.5355Z",
    fill: "#483D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.199 28.6759C25.8005 28.6759 25.395 28.6482 24.9826 28.5858C24.5805 28.5269 24.3067 28.1525 24.3656 27.7504C24.4246 27.3518 24.7954 27.0745 25.2009 27.1335C27.523 27.4801 29.5851 26.6031 30.4551 24.8943C30.6387 24.5338 31.0824 24.3917 31.4428 24.5754C31.8033 24.7591 31.9454 25.2028 31.7651 25.5633C30.7635 27.5251 28.6563 28.6759 26.2025 28.6759H26.199Z",
    fill: "#562912"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3567_12235",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3567_12235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3567_12235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_3567_12235",
    x: 5.99805,
    y: 4.00073,
    width: 35.0002,
    height: 35.0037,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.835294 0 0 0 0 0.435294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3567_12235"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.616667 0 0 0 0 0.434655 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3567_12235",
    result: "effect2_innerShadow_3567_12235"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3567_12235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(8 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiVerde);
export default __webpack_public_path__ + "static/media/emoji_verde.df468e269dcce141e55d51d76ef727f5.svg";
export { ForwardRef as ReactComponent };